import { Api, BuildVersion, currentver, ENCRYPT_STORAGE } from "../../config/config";
import { dto_MobileAppCategory } from "../../classes/dto-mobile-app-category";
import { dto_Customer } from "../../classes/dto-customer";
import { postMethod } from "../post";
import { dto_common } from "../../classes/dto-common";
import { ENTRY_MODE } from "../../database/store-names";
let Device;

//#region CheckCurentVersion
export const api_checkAppStoreVersion = async () => {
  var url = `${Api}/?ControllerName104=/ApiHome`;
  Device = "ANDROID";
  let device = window.navigator.appVersion;
  if (device !== undefined) {
    if (device.toUpperCase().includes("ANDROID")) {
      Device = "ANDROID";
    }
    if (device.toUpperCase().includes("IPHONE")) {
      Device = "IOS";
    }
    if (device.toUpperCase().includes("IPAD")) {
      Device = "IOS";
    }
  } else {
    Device = "ANDROID";
  }

  return postMethod(
    url,
    '{"SERVICENAME":"CheckMobileVersionForHardRelease","DEVICETYPE":"' +
      Device +
      '","VERSION":"' +
      currentver +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","NIC":"' +
      dto_Customer.NIC +
      '","CSID":' +
      dto_Customer.CSID +
      "}",
  );
};
//#endregion

//#region CheckCurentVersion
export const api_checkbuildversion = async () => {
  //var url = `${Api}/?ControllerName104=/ApiHome`;
  var url = `${Api}/?ControllerName104=/ApiHome`;
  //   if (Platform.OS === "ios") {
  //     Device = "IOS";
  //   } else {
  //     Device = "ANDROID";
  //   }
  Device = "ANDROID";
  let device = window.navigator.appVersion;
  if (device !== undefined) {
    if (device.toUpperCase().includes("ANDROID")) {
      Device = "ANDROID";
    }
    if (device.toUpperCase().includes("IPHONE")) {
      Device = "IOS";
    }
    if (device.toUpperCase().includes("IPAD")) {
      Device = "IOS";
    }
  } else {
    Device = "ANDROID";
  }
  return postMethod(
    url,
    '{"SERVICENAME":"CheckMobileVersionForSoftRelease","DEVICETYPE":"' +
      Device +
      '","VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","NIC":"' +
      dto_Customer.NIC +
      '","CSID":' +
      dto_Customer.CSID +
      "}",
  );
};
//#endregion

//#region StartupPageLoad
export const api_StartupPageLoad = () => {
  var url = `${Api}/?ControllerName104=/ApiHome`;
  // var url = `${Api}/?ControllerName104=/ApiHome`;
  return postMethod(
    url,
    '{"SERVICENAME":"LoadMobileSystemSettingsData","ZONEID":0,"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","NIC":"' +
      dto_Customer.NIC +
      '","CSID":' +
      dto_Customer.CSID +
      "}",
  );
};
//#endregion

//#region LoadMerchant
export const api_LoadMerchant = (
  DINETYPE,
  COORDINATES = dto_common.CurrentCordinate,
  SCHEDULEDORDER = false,
) => {
  var url = `${Api}/?ControllerName104=/ApiHome`;
  // let Cordinate = "";
  // if (DINETYPE === 3) {
  //   Cordinate = dto_common.PicupCordinate;
  // } else {
  //   Cordinate = COORDINATES;
  // }

  return postMethod(
    url,
    '{"SERVICENAME":"LoadMerchantListToHomePageCustomerApp","MERCHANTZONEID":' +
      dto_common.ZoneId +
      ',"ZONEID":' +
      dto_common.DeliveryZoneID +
      ',"SCHEDULEDORDER":' +
      SCHEDULEDORDER +
      ',"MTYPE":"' +
      dto_common.MTYPE +
      '","DINETYPE":' +
      DINETYPE +
      ',"CSID":' +
      dto_Customer.CSID +
      ',"VERSION":"' +
      BuildVersion +
      '" ,"CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.PicupCordinate +
      '"}',
  );
};
//#endregion

//#region LoadMerchanttForMID
export const api_LoadMerchantForMID = (DINETYPE, MID, IsPOSDivert = false) => {
  var url = `${Api}/?ControllerName104=/ApiHome`;
  let SCHEDULEDORDER = false;
  const entryMode = String(ENCRYPT_STORAGE.getItem(ENTRY_MODE) || "").trim();
  const ISERP = entryMode.toUpperCase() === "QR";
  return postMethod(
    url,
    '{"SERVICENAME":"LoadMerchantDataForMID","MERCHANTZONEID":' +
      dto_common.ZoneId +
      ',"ZONEID":' +
      dto_common.DeliveryZoneID +
      ',"SCHEDULEDORDER":' +
      SCHEDULEDORDER +
      ',"ISPOSDIVERT":' +
      IsPOSDivert +
      ',"MTYPE":"' +
      dto_common.MTYPE +
      '","DINETYPE":' +
      DINETYPE +
      ',"CSID":' +
      dto_Customer.CSID +
      ',"VERSION":"' +
      BuildVersion +
      '" ,"CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.PicupCordinate +
      '","ISERP":' +
      ISERP +
      ',"MID":' +
      MID +
      "}",
  );
};
//#endregion

//#region FilterMerchantsNProduct
export const api_FilterMerchantsNProducts = (TYPE = 1, SearchDesc) => {
  var url = `${Api}/?ControllerName104=/ApiHome`;
  let zoneID = 0;
  if (dto_common.CSP !== "AV") {
    if (
      dto_common.DeliveryZoneID === 0 ||
      dto_common.DeliveryZoneID === "0" ||
      dto_common.DeliveryZoneID === ""
    ) {
      zoneID = dto_common.ZoneId;
    } else {
      zoneID = dto_common.DeliveryZoneID;
    }
  } else {
    zoneID = dto_common.ZoneId;
  }
  return postMethod(
    url,
    '{"SERVICENAME":"FilterMerchantsNProducts","TYPE":' +
      TYPE +
      ',"CSID":' +
      dto_Customer.CSID +
      ',"ZONEID":' +
      zoneID +
      ',"DINETYPE":' +
      dto_common.DineType +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","PRODUCTDESC":"' +
      SearchDesc +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","NIC":"' +
      dto_Customer.NIC +
      '"}',
  );
};
//#endregion

//#region LoadMerchantsToMobileAppCategory
export const api_LoadMerchantsToMobileAppCategory = () => {
  var url = `${Api}/?ControllerName104=/ApiHome`;
  return postMethod(
    url,
    '{"SERVICENAME":"LoadMerchatsTo_A_MobileAppCategory", "MACID":' +
      dto_MobileAppCategory.MACID +
      ',"MERCHANTZONEID": ' +
      dto_common.ZoneId +
      ',"ZONEID":' +
      dto_common.DeliveryZoneID +
      ',"MID": 0,"MTYPE":"' +
      dto_common.MTYPE +
      '","DINETYPE":' +
      dto_common.DineType +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","NIC":"' +
      dto_Customer.NIC +
      '","CSID":' +
      dto_Customer.CSID +
      "}",
  );
};
//#endregion

//#region ForceSignOut
export const api_IsCustomerForcedToSignout = () => {
  var url = `${Api}/?ControllerName104=/ApiHome`;
  return postMethod(
    url,
    '{"SERVICENAME":"IsCustomerForcedToSignout","CSID":' +
      dto_Customer.CSID +
      "}",
  );
};
//#endregion

//#region LoadDevisons
export const api_LoadDevisons = () => {
  var url = `${Api}/?ControllerName104=/ApiHome`;
  return postMethod(url, '{"SERVICENAME":"LoadDevisons"}');
};
//#endregion

//#region LoadDevisons
export const api_UpdateIsFavouriteForMerchant = (MID, IsFavourite) => {
  var url = `${Api}/?ControllerName104=/ApiHome`;
  return postMethod(
    url,
    '{"SERVICENAME":"UpdateIsFavouriteForMerchant", "MID" : ' +
      MID +
      ',"IsFavourite":' +
      IsFavourite +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","NIC":"' +
      dto_Customer.NIC +
      '","CSID":' +
      dto_Customer.CSID +
      "}",
  );
};
//#endregion
